import { ResponseService } from './';
import { ethers } from 'ethers';

import nftAbi from '../abi/nft.abi.json';
import erc20Abi from '../abi/erc20.abi.json';

const isMetaMaskInstalled = () => {
  //Have to check the ethereum binding on the window object to see if it's installed
  const { ethereum } = window;
  if (!ethereum) {
    return ResponseService.buildFailure(
      'Metamask is not installed, Please install metamask to connect the wallet.',
    );
  }
  return ResponseService.buildSuccess('Metamask is installed.', ethereum);
};

const getTokenContractInstance = (
  _providerOrSignerInst,
  _projectType,
  _contractAddress,
) => {
  /* ----------------------------------------------------------------
    | initialize wrapped token contract instance using 
    | contract address, ABI, Signer 
    ----------------------------------------------------------------- */

  return new ethers.Contract(
    _contractAddress,
    _projectType === 'asset' ? nftAbi : erc20Abi,
    _providerOrSignerInst,
  );
};

const getChainInstances = async (
  _projectType = null,
  _contractAddress = null,
) => {
  try {
    let _chainInstances = {
      provider: null,
      privateProvider: null,
      signer: null,
      tokenInstance: null,
    };

    // if (_isPrivateInstance === true) {
    let _metamaskResp = isMetaMaskInstalled();
    //Created check function to see if the MetaMask extension is installed
    if (_metamaskResp.status === 'failure') {
      return _metamaskResp;
    }

    /* ----------------------------------------------------------------
      | Set Provider for Metamask
      ---------------------------------------------------------------- */
    _chainInstances.privateProvider = new ethers.BrowserProvider(
      _metamaskResp.data,
    );

    _chainInstances.signer = await _chainInstances.privateProvider.getSigner();

    if (_projectType != null && _contractAddress != null) {
      _chainInstances.tokenInstance = getTokenContractInstance(
        _chainInstances.signer,
        _projectType,
        _contractAddress,
      );
    }
    // }
    // else {
    //   _chainInstances.provider = new ethers.JsonRpcProvider(
    //     ConfigService.blockchainRpcEndpoint()
    //   );

    //   if(_contractAddress != null){
    //     _chainInstances.tokenInstance = getTokenContractInstance(_chainInstances.provider, _contractAddress);
    //   }
    // }

    return ResponseService.buildSuccess('Instances fetched', _chainInstances);
  } catch (error) {
    return ResponseService.buildBlockchainFailure(error);
  }
};

const connectWallet = async () => {
  try {
    let _instanceResp = await getChainInstances();

    if (_instanceResp.status === 'failure') {
      return _instanceResp;
    }

    const {
      data: { privateProvider, signer },
    } = _instanceResp;

    await privateProvider.send('eth_requestAccounts', []);

    /* ----------------------------------------------------------------
    | Get wallet address from connected metamask account
    ---------------------------------------------------------------- */
    const walletAddress = await signer.getAddress();

    let _balance = await privateProvider.getBalance(walletAddress);
    _balance = await formatEtherDecimals(_balance);
    return ResponseService.buildSuccess('Connection established', {
      walletAddress: walletAddress,
      balance: _balance,
    });
  } catch (error) {
    return ResponseService.buildBlockchainFailure(error);
  }
};

/**
 * This function normally formats the amount to 18 decimals, However, since we have
 * change the decimals to 0, we are returning the same amount.
 *
 * @param amount
 * @returns amount
 *
 */
const formatEtherDecimals = async (_amount) => {
  _amount = _amount.toString();
  return _amount;
};
/**
 * This function normally formats the amount from 18 decimals, However, since we have
 * change the decimals to 0, we are returning the same amount.
 *
 * @param amount
 * @returns amount
 *
 */
const parseEtherDecimals = async (_amount) => {
  _amount = _amount.toString();
  return _amount;
};

const handleNftFreeze = async (_projectType, _contractAddress, _isFreezed) => {
  try {
    let _instanceResp = await getChainInstances(_projectType, _contractAddress);

    if (_instanceResp.status === 'failure') {
      return _instanceResp;
    }
    const {
      data: { tokenInstance },
    } = _instanceResp;

    const _response =
      await tokenInstance[_isFreezed ? 'freezeTransfer' : 'unFreezeTransfer']();

    return ResponseService.buildSuccess(
      _isFreezed
        ? 'Project freeze has been enabled successfully'
        : 'Project freeze has been desabled successfully',
      _response,
    );
  } catch (error) {
    return ResponseService.buildBlockchainFailure(error);
  }
};

const mintToken = async (_projectType, _contractAddress, mintQty) => {
  try {
    let _instanceResp = await getChainInstances(_projectType, _contractAddress);

    if (_instanceResp.status === 'failure') {
      return _instanceResp;
    }

    const {
      data: { tokenInstance },
    } = _instanceResp;
    if (_projectType === 'bond') {
      mintQty = mintQty.toString();
    }
    const _response = await tokenInstance.mint(mintQty);
    return ResponseService.buildSuccess(
      'Tokens minted successfully',
      _response,
    );
  } catch (error) {
    return ResponseService.buildBlockchainFailure(error);
  }
};

const networkDetails = async () => {
  try {
    /* ----------------------------------------------------------------
    | Get Wallet balance and address from connected metamask account
    ---------------------------------------------------------------- */
    let _instanceResp = await getChainInstances();
    if (_instanceResp.status === 'failure') {
      return _instanceResp;
    }

    const {
      data: { privateProvider },
    } = _instanceResp;

    const _networkInfo = await privateProvider.getNetwork();

    return ResponseService.buildSuccess(
      'Network details fetched successfully',
      _networkInfo,
    );
  } catch (error) {
    return ResponseService.buildBlockchainFailure(error);
  }
};

export {
  isMetaMaskInstalled,
  formatEtherDecimals,
  networkDetails,
  connectWallet,
  handleNftFreeze,
  mintToken,
  parseEtherDecimals,
};
